function MSAssignmentReportCreators() {
    /// <summary>
    /// This object provides js functions for the Widget.Membership.Assigment.* <br/>
    /// <br/>
    /// Author: MWI<br />
    /// Date: 11.04.2017<br />
    /// Copyright ©: EUDT GmbH 2017 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 11.5.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// * - includes special functions for handling the extra items          *<br />
    /// **********************************************************************<br />
    /// </summary>
  
}

MSAssignmentReportCreators.prototype = new window.MSAssignment();
  MSAssignmentReportCreators.prototype.init = function (id) {
    /// <summary>
    /// Overload of the parent fucntion to init the assignment 
    /// </summary>
    var me = this;
    try {
    window.MSAssignment.prototype.init.call(me, id);
        me.visual.find('.vc-list').height(me.visual.height() - 140);
        me.visual.find("#divTarget").css({ "float": "left" });
    } catch (ex) {
        me.writeError('MSAssignmentReportCreators.loadItems', ex);
    }
};
MSAssignmentReportCreators.prototype.loadItems = function (id) {
    /// <summary>
    /// Overload of the parent fucntion to load the items
    /// </summary>
    var me = this;
    try {
        me.parameter = "";
        me.signalParameter = "";

    me.assID = -1;
    window.MSAssignment.prototype.loadItems.call(me, id);
    } catch (ex) {
        me.writeError('MSAssignmentReportCreators.loadItems', ex);
    }
};


MSAssignmentReportCreators.prototype.addspecificClickHandler = function () {
    /// <summary>
    /// This function inits the assigment specific click handler if implemented
    /// </summary>
    ///<param name='row'> a row object to add the item </param>
    var me = this;
    try {
        if (me.error) { return false; }
        //_VCMQ.addConsumer(me.vcgid);
        //_VCMQ.consume(me.visual, me.vcgid, function(event) {me.doEvent(event)});
        me.visual.find("#lstTarget").off("click").on("click", " .uedit", function(event) {
            me.clickEditUserButon(event, this);
        });
        me.visual.find("#lstTarget").off("dblclick").on("dblclick", " .uedit", function (event) {
            event.stopPropagation();
        });
    } catch (ex) {
        me.writeError('MSAssignmentReportCreators.addspecificClickHandler', ex);
        return false;
    }
    return true;
};
MSAssignmentReportCreators.prototype.clickEditUserButon = function(event, element) {
    /// <summary>
    /// This handles the click of the user edit button
    /// by changing the appearance and getting the update call
    /// </summary>
    var me = this;
    var getObj;
    var edit;
    try {
        event.stopPropagation();
        if ($(element).find("input")[0].checked === true) {
            $(element).attr("title", me.resources.reportUserCanEdit);
            edit = true;
        } else {
            $(element).attr("title", me.resources.reportUserCannotEdit);
            edit = false;
        }
      
        getObj = JSON.stringify({'type': 3,'id': $(element).data("uid"),'assID': me.assID,"allowedToEditTemplate": edit});
        window.VisualCoreService.updateData(me.vcvid,me.vcgid,window.getCurrentTimestamp(),0,0,'','',me.deviceType,me.langid,getObj,
            function (result) {
                var bRetService = true;
                if (result !== true) {
                    me.showMessage(me.resources.err_saveData, true);
                    bRetService=  false;
                }
                if (me.VCMQ_update_message.length > 0) {
                  me._VCMQ.produce(me.visual, me.vcgid, me.VCMQ_update_message, '');
                    bRetService = true;
                }
                return bRetService;
            });
    } catch (ex) {
        me.writeError('MSAssignmentReportCreators.clickEditUserButon', ex);

    }
    return true;
};
MSAssignmentReportCreators.prototype.addAssignmentItemSpecifics = function (row) {
    /// <summary>
    /// This function inits the assigment specific icons if implemented
    /// </summary>
    ///<param name='row'> a row object to add the item </param>
    var me = this;
    var sTmp = "";
    try {
        if (me.error) { return false; }
        if (row.locked === false) {
            sTmp += me.resources.icon_user_locked + " ";
        }
        if (row.registered === false) {
            sTmp += me.resources.icon_user_unregistered + " ";
        }
        if (row.deleted === true) {
            sTmp += me.resources.icon_user_deleted + " ";
        }
        if (row.owner === true) {
            sTmp += me.resources.icon_user_owner + " ";
            row.edit = true;
        }
        if (row.delete === true) {

            sTmp += "<div class='uedit'  data-uid='" +
                row.id +
                "' data-edit='" +
                row.edit +
                "' title='" +
                (row.edit === true ? me.resources.reportUserCanEdit : me.resources.reportUserCannotEdit) +
                "'>";
                            sTmp += "<input type='checkbox'";

            if (row.edit === true) {

                sTmp += "checked='checked'";


            }
            sTmp += "/>";
            sTmp += " " + me.resources.edit + "</div>";

        }
        return sTmp;
    } catch (ex) {
        me.writeError('MSAssignmentReportCreators.addAssignmentmentItemSpecifics', ex);
        return false;
    }
};


